export const GET_ALL_BLOGS_REQUEST = 'GET_ALL_BLOGS_REQUEST'
export const GET_ALL_BLOGS_SUCCESS = 'GET_ALL_BLOGS_SUCCESS'
export const GET_ALL_BLOGS_FAILED = 'GET_ALL_BLOGS_FAILED'


export const GET_SINGLE_BLOG_REQUEST = 'GET_SINGLE_BLOG_REQUEST'
export const GET_SINGLE_BLOG_SUCCESS = 'GET_SINGLE_BLOG_SUCCESS'
export const GET_SINGLE_BLOG_FAILED = 'GET_SINGLE_BLOG_FAILED'